import moment from "moment";

export default {
    filters: {
        testFilter(value) {
            return `${value} - test`;
        },
        caseNumberText(value) {
            if (value) {
                return `Case#${value}`;
            }

            return null;
        },
        convertToNotApplicable(value) {
            if (value) {
                return value;
            }

            return "N/A";
        },
        convertToScheduleDateTime(value) {
            if (value) {
                return moment(value).format("MMM DD, YYYY LT")
            }

            return null;
        },
        consultationText(value) {
            if (value) {
                return `${value} (for this case)`;
            }

            return value;
        },
        birthdateText(value) {
            if (value) {
                let convertToTimestamp = new Date(value);

                return moment(convertToTimestamp).format("ll");
            }

            return null;
        },
        convertToYesNoText(value) {
            if (value) {
                return "Yes";
            }

            return "No";
        }
    }, 
}